// Modules
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';

// Web Components
import { defineCustomElements } from '@dofinity/biu-components/loader';
 
// Store
import store from './store/config/configureStore';

// App
import App from './App';

ReactDOM.render(
	<React.StrictMode>
		<Provider store={store}>
			<BrowserRouter>
				<App />
			</BrowserRouter>
		</Provider>
	</React.StrictMode>,
	document.getElementById('root'),
);

defineCustomElements(window);
